import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session-data`, {
          method: "GET",
          headers: { "X-Session-ID": sessionId },
          credentials: "include",
        });
        if (!res.ok) throw new Error("session exchange failed");
        const data = await res.json();
        setUser(data);
        // First sign-in: merge any guest layout + journal into this account.
        try {
          const clientId = localStorage.getItem("ws_client_id");
          if (clientId) {
            await fetch(`${API}/merge-guest`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({ client_id: clientId }),
            });
          }
        } catch (_) { /* non-blocking */ }
      } catch (e) {
        // fall through to home
      } finally {
        window.history.replaceState(null, "", window.location.origin + "/");
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="ws-live-dot mx-auto mb-4" />
        <p className="text-[color:var(--ws-muted)] text-sm">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
